import { css } from 'styled-components'

const danger = () => css`
  .hot-button.hot-button--danger {
    background-color: var(--red) !important;
  }
  .hot-button.hot-button--danger:hover,
  .hot-button.hot-button--danger:focus,
  .hot-button.hot-button--danger:active,
  .hot-button.hot-button--danger.hot-button--active {
    background-color: var(--red-dark) !important;
  }

  .hot-button.hot-button--danger:focus,
  .hot-button.hot-button--danger:active {
    background-color: var(--red-darker) !important;
  }

  .hot-button.hot-button--danger:disabled,
  .hot-button.hot-button--danger.hot-button--disabled {
    background-color: var(--gray-400) !important;
  }
`

export default danger
